import '@ff/app-ui/styles.css';
import './styles/app.css';
import { render } from 'preact';
import { setTransport } from './lib/api.ts';
import { setSignedOutHandler } from './lib/data.ts';
import { flush } from './lib/outbox.ts';
import { navigate } from './lib/router.ts';
import { boot, session } from './lib/session.ts';
import { applyTheme, theme } from './lib/ui.ts';
import { registerServiceWorker } from './pwa/pwa.ts';
import { App } from './app.tsx';

declare const __FF_DEMO__: boolean;

async function start() {
  applyTheme(theme.get());
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => applyTheme(theme.get()));
  if (__FF_DEMO__) {
    const { createDemoApi, readDemo } = await import('./mock/server.ts');
    setTransport(createDemoApi(readDemo(window.location.search)));
    document.documentElement.dataset.demo = '';
  }
  setSignedOutHandler(() => {
    session.set({ status: 'signed_out' });
    navigate(`/signin?next=${encodeURIComponent(window.location.pathname)}`, { replace: true });
  });
  registerServiceWorker();
  const root = document.getElementById('app')!;
  render(<App />, root);
  await boot();
  void flush();
}

void start();
